import Card from "react-bootstrap/Card"
import "./style.css"
import React, { useEffect, useState } from "react";
import { Chart } from "./Chart"
import { getSRResponse } from "../../services/util/historicalComponentsResponses";
import { ThreeDots } from 'react-loader-spinner'
import { useSelector } from "react-redux";
import { log } from "console";


export const SuccessRatioCard = ({ filterDropdownVersion, type, startandEndDate, heatmapVersion, asset, currContractDiv }: any) => {

    const [srResponse, setSRResponse] = useState<any>([])
    const [loading, setLoading] = useState<any>(true)
    const [error, setError] = useState<any>(null)
    let tradetype: any = 'Total'

    const theme: any = useSelector((state: any) => {
        return state.theme.isTheme;
      })



    useEffect(() => {

        if (startandEndDate !== null) {
            try {
                const fetchSRResponse: any = async () => {
                    setSRResponse([])
                    setLoading(true)
                    let response: any = await getSRResponse(startandEndDate?.start_date, startandEndDate?.end_date, asset, heatmapVersion, type, tradetype, filterDropdownVersion)
                    setSRResponse(response)
                    setLoading(false)
                }
                fetchSRResponse()
            } catch (error) {
                console.log("Error while fetching success ratio response for ", type, error)
                setError(error)
            }
            finally {
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startandEndDate, heatmapVersion, asset])


    return <>
        {loading ? <ThreeDots visible={true}
            height="60"
            width="60"
            color="#8eabc5"
            radius="9"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClass="" />
            :
            currContractDiv || ['equityMultiday','equityN50BANK'].includes(type)?
                <Card className="custom-card card2 " style={{ background: "transparent" }}>
                    <div className=" total_currContractDiv heading" style={{ display: "inline-block", marginTop: "-0.3rem" }}>
                        {theme == 'dark' || theme == 'b&w' ? <img style={{ height: "1.8rem", marginRight: "1rem", width: "1.8rem", display: "inline-block" }} src="/images/sr.png" alt="sr"/>
                            : theme == 'light' ? <img style={{ height: "1.8rem", marginRight: "1rem", width: "1.8rem", display: "inline-block" }} src="/images/sr_light.png" alt="sr_light"/> : ''}
                        Success Ratio {(srResponse?.total)?.toFixed(2)}%
                    </div>
                </Card>
                : <Card className="custom-card card2">
                    <div className=" total heading" style={{ display: "inline-block" }}>
                        {theme == 'dark' || theme == 'b&w' ? <img style={{ height: "1.8rem", marginRight: "1rem", width: "1.8rem", display: "inline-block" }} src="/images/sr.png" alt="sr"/>
                            : theme == 'light' ? <img style={{ height: "1.8rem", marginRight: "1rem", width: "1.8rem", display: "inline-block" }} src="/images/sr_light.png" alt="sr_light" /> : ''}
                        Success Ratio {(srResponse?.total)?.toFixed(2)}%
                    </div>

                    {!['equityMultiday','equityN50BANK'].includes(type) ?
                        <>
                            <div className="months">
                                {srResponse?.data?.map((data: any, index: any) => {
                                    return <Card.Subtitle className="mb-2 " key={index}>
                                        {((data.month)?.slice(0, 3))?.toUpperCase()} {data.year}{" "}: {(data.value)?.toFixed(2)}</Card.Subtitle>
                                })}
                            </div>
                            <Chart dataset={srResponse?.data} name="Success Ratio" />
                        </>
                        : ""}
                </Card>}
    </>
}